"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiPostQueryResponse = instanceOfApiPostQueryResponse;
exports.ApiPostQueryResponseFromJSON = ApiPostQueryResponseFromJSON;
exports.ApiPostQueryResponseFromJSONTyped = ApiPostQueryResponseFromJSONTyped;
exports.ApiPostQueryResponseToJSON = ApiPostQueryResponseToJSON;
exports.ApiPostQueryResponseToJSONTyped = ApiPostQueryResponseToJSONTyped;
const ApiPostQueryResponseResultsInner_1 = require("./ApiPostQueryResponseResultsInner");
const ApiPostQueryRequest_1 = require("./ApiPostQueryRequest");
/**
 * Check if a given object implements the ApiPostQueryResponse interface.
 */
function instanceOfApiPostQueryResponse(value) {
    if (!('success' in value) || value['success'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
function ApiPostQueryResponseFromJSON(json) {
    return ApiPostQueryResponseFromJSONTyped(json, false);
}
function ApiPostQueryResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'success': json['success'],
        'cache': json['cache'] == null ? undefined : json['cache'],
        'duration': json['duration'] == null ? undefined : json['duration'],
        'sql': json['sql'] == null ? undefined : json['sql'],
        'tables': json['tables'] == null ? undefined : json['tables'],
        'results': json['results'] == null ? undefined : (json['results'].map(ApiPostQueryResponseResultsInner_1.ApiPostQueryResponseResultsInnerFromJSON)),
        'queryParams': json['query_params'] == null ? undefined : (0, ApiPostQueryRequest_1.ApiPostQueryRequestFromJSON)(json['query_params']),
        'tableName': json['table_name'] == null ? undefined : json['table_name'],
        'total': json['total'] == null ? undefined : json['total'],
        'status': json['status'],
        'info': json['info'] == null ? undefined : (0, ApiPostQueryRequest_1.ApiPostQueryRequestFromJSON)(json['info']),
        'message': json['message'] == null ? undefined : json['message'],
        'count': json['count'] == null ? undefined : json['count'],
    };
}
function ApiPostQueryResponseToJSON(json) {
    return ApiPostQueryResponseToJSONTyped(json, false);
}
function ApiPostQueryResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'success': value['success'],
        'cache': value['cache'],
        'duration': value['duration'],
        'sql': value['sql'],
        'tables': value['tables'],
        'results': value['results'] == null ? undefined : (value['results'].map(ApiPostQueryResponseResultsInner_1.ApiPostQueryResponseResultsInnerToJSON)),
        'query_params': (0, ApiPostQueryRequest_1.ApiPostQueryRequestToJSON)(value['queryParams']),
        'table_name': value['tableName'],
        'total': value['total'],
        'status': value['status'],
        'info': (0, ApiPostQueryRequest_1.ApiPostQueryRequestToJSON)(value['info']),
        'message': value['message'],
        'count': value['count'],
    };
}
